import { useEffect, useRef, useState } from 'react';
import useSound from '@mrmartineau/use-sound';
import { getBaseCard, getCardVariant, humanCardName } from '../utils/cards';
import CardVariantOverlay from '../CardVariantOverlay';
import openingSxf from '../sounds/wash.mp3';
import openedSxf from '../sounds/magic.mp3';

export function GiftClaimModal({ isOpen, card, onClose, cardImageFolder = 'smallcards' }) {
  const [isOpeningBoosterPack, setIsOpeningBoosterPack] = useState(false);
  const openingTimeoutRef = useRef(null);
  const [playOpeningSound] = useSound(openingSxf);
  const [playOpenedSound] = useSound(openedSxf);
  const earnedVariant = card ? getCardVariant(card) : null;

  useEffect(() => {
    return () => {
      if (openingTimeoutRef.current) {
        clearTimeout(openingTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (!isOpen || !card) return;

    setIsOpeningBoosterPack(true);
    playOpeningSound();
    openingTimeoutRef.current = setTimeout(() => {
      playOpenedSound();
      setIsOpeningBoosterPack(false);
      openingTimeoutRef.current = null;
    }, 1500);
  }, [isOpen, card, playOpenedSound, playOpeningSound]);

  if (!isOpen || !card) return null;

  return (
    <>
      <div className={`modal victory-modal gift-claim-modal ${isOpen ? 'open' : 'closed'}`}>
        <div className='modal-overlay' onClick={onClose}></div>
        <div className='modal-content'>
          <h2>Gift Claimed!</h2>
          <div className='winnings-box'>
            <p>
              You received <strong>{humanCardName(card)}!</strong>
              <br />
              <small>The card has been added to your collection.</small>
            </p>

            <div className='fancy-card-stack'>
              {!isOpeningBoosterPack ? (
                <>
                  <div className='card'><img alt='' className='front' src={`./assets/${cardImageFolder}/back1.png`} /></div>
                  <div className='card'><img alt='' className='front' src={`./assets/${cardImageFolder}/back1.png`} /></div>
                  <div className='card'><img alt='' className='front' src={`./assets/${cardImageFolder}/back1.png`} /></div>

                  <div className={`card ${earnedVariant ?? ''}`}>
                    {earnedVariant ? (
                      <CardVariantOverlay
                        variant={earnedVariant}
                        imageSrc={`./assets/${cardImageFolder}/${getBaseCard(card).toLowerCase()}.png`}
                        alt={card}
                        title={humanCardName(card)}
                        className='front'
                      />
                    ) : (
                      <img alt={card} className='front' src={`./assets/${cardImageFolder}/${getBaseCard(card).toLowerCase()}.png`} />
                    )}
                  </div>
                </>
              ) : (
                <div className='card booster opening'>
                  <CardVariantOverlay
                    variant='booster'
                    imageSrc='./assets/misc/booster.png'
                    alt='Booster Pack'
                    title='Booster Pack'
                    className='front'
                  />
                </div>
              )}
            </div>
          </div>

          <div className='modal-buttons'>
            <button className='big' onClick={onClose}>Nice</button>
          </div>
        </div>
      </div>
      {isOpeningBoosterPack && <div className='booster-opening-overlay'></div>}
    </>
  );
}
